import { AnalyticsTransformer, TrackingData } from '@panamax/app-state';

export const handPricingModalOpen: AnalyticsTransformer = (
  tracking: TrackingData,
) => ({
  event: tracking.data.event,
  capability: tracking.data.capability,
  products: tracking.data.products,
  modal: {
    name: tracking.data.modalName,
  },
});

export const handPricingValueChange: AnalyticsTransformer = (
  tracking: TrackingData,
) => ({
  event: tracking.data.event,
  capability: tracking.data.capability,
  products: tracking.data.products,
});

export const shareViaEmailOrderOpenModal = (tracking: TrackingData) => {
  const { capability, event, modalName } = tracking.data;

  return {
    capability,
    event,
    modal: {
      name: modalName,
    },
  };
};

export const shareViaEmailOrder = (tracking: TrackingData) => {
  const { capability, event, fileType } = tracking.data;

  return {
    capability,
    event,
    file: {
      type: fileType,
    },
  };
};

/**
 * DEFAULT TRANFORMER
 *
 * @param tracking
 * @returns Data Layer when no change is needed
 */
export const defaultTransformer = (tracking: TrackingData) => ({
  ...tracking.data,
});

/**
 * ORDER PAGE LOAD
 *
 * @param tracking
 * @returns Data Layer needed for tracking the Order Page Load
 */
export const orderPageLoad = (tracking: TrackingData) => ({
  ...tracking.data,
});
